<template>
  <div :class="['mob-message', containerClasses]">
    <div :class="['mob-message-heading', headingClasses]" v-if="heading">
      <Icon :icon="icon" height="25" />
      <h4>{{ heading }}</h4>
      <!-- prettier-ignore -->
      <svg xmlns="http://www.w3.org/2000/svg" width="110" height="127" fill="none" viewBox="0 0 110 127" class="absolute right-0 -top-4">
        <path fill="#fff" fill-opacity=".2" d="M51.357.994a7.175 7.175 0 0 1 7.286 0l47.714 28.041C108.611 30.36 110 32.81 110 35.458v56.084c0 2.65-1.389 5.098-3.643 6.423l-47.714 28.041a7.174 7.174 0 0 1-7.286 0L3.643 97.965C1.389 96.64 0 94.19 0 91.542V35.458c0-2.65 1.389-5.098 3.643-6.423L51.357.994Z"/>
        <path stroke="#fff" stroke-opacity=".2" stroke-width="2" d="m58.136 41.982 47.714 28.041c1.944 1.143 3.15 3.26 3.15 5.561v15.958c0 2.3-1.206 4.418-3.15 5.56l-47.714 28.042a6.175 6.175 0 0 1-6.272 0L4.15 97.102C2.206 95.96 1 93.842 1 91.542V75.584c0-2.3 1.206-4.418 3.15-5.56l47.714-28.042a6.175 6.175 0 0 1 6.272 0ZM109 70.1a8.306 8.306 0 0 0-2.136-1.8L59.149 40.256a8.175 8.175 0 0 0-8.299 0L3.136 68.3A8.306 8.306 0 0 0 1 70.1V35.458c0-2.3 1.206-4.418 3.15-5.56L51.864 1.856a6.175 6.175 0 0 1 6.272 0l47.714 28.042c1.944 1.142 3.15 3.26 3.15 5.56V70.1Z"/>
      </svg>
    </div>
    <div class="mob-message-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";

export default {
  name: "MobMessage",
  components: {
    Icon,
  },
  props: {
    heading: String,
    type: {
      type: String,
      default: "info",
      validator: (value) => ["info", "warning", "error"].includes(value),
    },
  },
  data() {
    return {
      containerClasses: "",
      headingClasses: "",
      icon: "",
    };
  },
  methods: {
    setBgColorClass() {
      switch (this.type) {
        case "info":
          this.containerClasses = "border-blue-600";
          this.headingClasses = "from-[#2D8FFE] to-[#C1DAF6] border-blue-600";
          this.icon = "iconamoon:information-circle-light";
          break;
        case "warning":
          this.containerClasses = "border-yellow-600";
          this.headingClasses =
            "from-yellow-600 to-yellow-200 border-yellow-600";
          this.icon = "iconamoon:information-circle-light";
          break;
        case "error":
          this.containerClasses = "border-red-600";
          this.headingClasses = "from-red-600 to-red-200 border-red-600";
          this.icon = "iconamoon:information-circle-light";
          break;
        default:
          this.containerClasses = "";
          this.headingClasses = "";
          this.icon = "iconamoon:information-circle-light";
      }
    },
  },
  mounted() {
    this.setBgColorClass();
  },
};
</script>

<style>
/* Estilos del componente aquí */
.mob-message {
  @apply rounded-md border overflow-hidden;
}

.mob-message-heading {
  @apply flex items-center gap-2 px-3 py-2 border-b font-bold text-white bg-gradient-to-r relative;
}

.mob-message-content {
  @apply leading-tight p-3 text-neutral-500;
}
</style>
